import { render, staticRenderFns } from "./pwa_article_privacy.vue?vue&type=template&id=c7c22776&scoped=true&"
import script from "./pwa_article_privacy.vue?vue&type=script&lang=js&"
export * from "./pwa_article_privacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c22776",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7c22776')) {
      api.createRecord('c7c22776', component.options)
    } else {
      api.reload('c7c22776', component.options)
    }
    module.hot.accept("./pwa_article_privacy.vue?vue&type=template&id=c7c22776&scoped=true&", function () {
      api.rerender('c7c22776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/settings/tabs/texts/pwa_article_privacy.vue"
export default component.exports